import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import dataReducer from "@wausauCustomBlueprint/Store/Data/DataReducer";

// To OOTB reducers adding our dataReducers by casting into any type
(reducers as any).tData = dataReducer;

type CustomReducers = {
    tData: typeof dataReducer;
};

// creating custom actions along our custom reducers & OOTB actions from AnyAction
export type CustomActions = Parameters<CustomReducers[keyof CustomReducers]>[1] | AnyAction;
